import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2, X } from 'lucide-react';
const NAMES = ['Laura', 'Gabriela', 'Rocío', 'Valeria', 'Micaela', 'Carolina', 'Sofía', 'Florencia', 'Camila', 'Agustina', 'Lucía', 'Martina', 'Julieta', 'Paula'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'Santa Fe', 'Tucumán', 'La Plata', 'Mar del Plata', 'Salta', 'Neuquén', 'San Juan', 'Resistencia'];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState({
    name: '',
    city: '',
    time: 0
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
      const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
      const randomTime = Math.floor(Math.random() * 15) + 1;
      setCurrentBuyer({
        name: randomName,
        city: randomCity,
        time: randomTime
      });
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 5000); // Hide after 5 seconds
    };
    // Initial delay before first popup
    const initialTimer = setTimeout(showPopup, 8000);
    // Then cycle every 30 seconds
    const intervalTimer = setInterval(() => {
      showPopup();
    }, 30000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(intervalTimer);
    };
  }, []);
  return <AnimatePresence data-id="element-49">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.95
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 25
    }} className="fixed bottom-4 left-4 z-50 max-w-sm w-[calc(100%-2rem)] md:w-auto bg-white rounded-xl shadow-2xl border border-wine-100 p-4 flex items-start gap-4" data-id="element-50">
          <div className="flex-shrink-0 mt-1" data-id="element-51">
            <div className="w-10 h-10 bg-wine-100 rounded-full flex items-center justify-center" data-id="element-52">
              <CheckCircle2 className="w-6 h-6 text-wine-700" data-id="element-53" />
            </div>
          </div>
          <div className="flex-1 pr-6" data-id="element-54">
            <p className="text-sm font-medium text-gray-900" data-id="element-55">
              <span className="font-bold" data-id="element-56">{currentBuyer.name}</span> de{' '}
              {currentBuyer.city} acaba de comprar
            </p>
            <p className="text-sm font-bold text-wine-700 mt-0.5" data-id="element-57">
              DANZA INFANTIL 360
            </p>
            <p className="text-xs text-gray-500 mt-1" data-id="element-58">
              hace {currentBuyer.time}{' '}
              {currentBuyer.time === 1 ? 'minuto' : 'minutos'}
            </p>
          </div>
          <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-gray-400 hover:text-gray-600 transition-colors" aria-label="Cerrar" data-id="element-59">
            <X className="w-4 h-4" data-id="element-60" />
          </button>
        </motion.div>}
    </AnimatePresence>;
}